<template>
  <span>
    <FilterNavigation v-model="drawer" @logout="logout" style="z-index:100;"/>

    <!-- <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Motiverse</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn @click="goToStartPage" icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-on="on"
            v-bind="attrs"
          >
          <div class="account">
          <div>
            <v-icon>mdi-account</v-icon>
          </div>
          <div class="userShort">
            <span>{{$store.getters.getUser.username.substring(0,2)}}</span>
          </div>
          </div>
          </v-btn>
        </template>
        <span>{{this.$store.getters.getUser.username}}</span>
      </v-tooltip>
      <v-btn text color="white" @click="logout">Logout</v-btn>
    </v-app-bar> -->
      <router-view v-if="colorFetched" name="model" />
      <update-dialog :dialog="showModal" title="Neue Funktionen sind verfügbar" :message="updateMessage" @close="close"/>
  </span>
</template>

<script>
import { hasSeenUpdate, setStoredVersion } from "@/components/modalService.js"
import FilterNavigation from "./FilterNavigation";
import clientService from "@/components/clientService"
import UpdateDialog from '../../components/common/UpdateDialog.vue';

export default {
  props: {
    source: String
  },
  components: {
    FilterNavigation,
    UpdateDialog
  },
  data: () => ({
    drawer: null,
    colorFetched: false,
    showModal: false,
    updateMessage: ""
  }),
  async created() {
    // this.$vuetify.theme.themes.light.secondary = "#2F2E2E";
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push("/");
    }
    clientService.getClientColor().then(res => {
      let color = 'FC9861';
      if(color == null || color == '') color = "FFFFFF"
      this.$vuetify.theme.themes.light.primary = "#"+color;
      this.colorFetched = true;
      this.$store.dispatch('setClientColor', color);
    });
    clientService.getClientIcon().then(res => {
      let icon = res.data;
      this.$store.dispatch('setClientIcon', icon);
    })
    if(!hasSeenUpdate()) {
      let img = require('@/assets/updateInfo.png');
      this.updateMessage = `<p><strong>Release Notes zur Version v4.2.7 (02.06.2025)</strong></p>
    <ul style="padding-left:48px;">
    <li>
    <p style="line-height:116%;margin-bottom:12.0pt;margin-right:0cm;margin-top:12.0pt;">
        <span style="font-family:Aptos, sans-serif;font-size:12pt;"></span>
        <span style="font-family:&quot;Open Sans SemiBold&quot;;font-size:11.0pt;">
            <strong>MO1-T289: </strong>
        </span>
        <span style="font-family:&quot;Open Sans Light&quot;;font-size:11.0pt;">
            Die Elementnummerierung funktioniert nun zuverlässig.
        </span>
        <br><br>&nbsp;
    </p>
</li>
<li>
    <p style="line-height:116%;margin-bottom:12.0pt;margin-right:0cm;margin-top:12.0pt;">
        <span style="font-family:Aptos, sans-serif;font-size:12pt;"></span>
        <span style="font-family:&quot;Open Sans SemiBold&quot;;font-size:11.0pt;">
            <strong>MO1-T295: </strong>
        </span>
        <span style="font-family:&quot;Open Sans Light&quot;;font-size:11.0pt;">
            Der Bericht wird nun nach DIN erstellt (inkl. letztem Bearbeitenden, Seitenzahl, etc.).
        </span>
        <br><br>&nbsp;
    </p>
</li>
<li>
    <p style="line-height:116%;margin-bottom:12.0pt;margin-right:0cm;margin-top:12.0pt;">
        <span style="font-family:Aptos, sans-serif;font-size:12pt;"></span>
        <span style="font-family:&quot;Open Sans SemiBold&quot;;font-size:11.0pt;">
            <strong>MO1-T296: </strong>
        </span>
        <span style="font-family:&quot;Open Sans Light&quot;;font-size:11.0pt;">
            Gelöschte Elemente werden nun berücksichtigt, sodass es nicht mehr zu einer Fehlermeldung kommt, wenn eine Aktivität mit der Zahl des gelöschten Elements nummeriert wird.
        </span>
        <br><br>&nbsp;
    </p>
</li>


</ul>
Sollten Sie Fragen haben oder Probleme mit den neuen Funktion feststellen, k&ouml;nnen Sie unseren Support &uuml;ber den Hilfebereich kontaktieren.</p>
      `;
    }
    this.showModal = !hasSeenUpdate();
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    goToStartPage() {
      this.$router.push("/menu");
    },
    close() {
      this.showModal = false;
      setStoredVersion();
    },
  }
};
</script>
<style>
.v-list-item__subtitle, .v-list-item__title{
  text-overflow: initial!important;
  white-space: initial!important;
}
.v-application{
  background-color: white !important;
}
.v-list .v-list-item--active{
  color: white !important;
}
tbody tr:nth-child(even) {
  background-color: white;
}
tbody tr{
  background-color: #F5F5F5;
  border-bottom: none;
}
</style>